/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
// Core Libraries
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  BrowserAnimationsModule,
  NoopAnimationsModule,
} from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

// Imported Modukes
import { WidgetsModule } from '@support/shared/widgets/widgets.module';

// Components
import { FooterComponent } from '@root/shared/components/footer/footer.component';
import { NavbarComponent } from '@root/shared/components/navbar/navbar.component';
import { GlobalErrorModalComponent } from '@root/shared/components/global-error-modal/global-error-modal.component';
import { SplashPageComponent } from '@root/shared/components/splash-page/splash-page.component';
import { SearchComponent } from '@root/shared/components/search/search.component';

// Directives
import { AnchorDetectDirective } from '@root/shared/directives/anchor-detection.directive';

// Services
import { UserService } from '@support/shared/services/user.service';
import { SetFocusService } from '@support/shared/widgets/services/set-focus.service';
import { NavbarService } from '@root/shared/services/navbar.service';
import { RepProfileService } from '@root/shared/services/rep-profile.service';
import { SearchService } from '@root/shared/services/search.service';
import { CustomerProfileService } from '@support/customer-login/services/customer-profile.service';
import { WorkflowService } from '@root/shared/services/workflow.service';
import { WorkflowCartSupportService } from '@root/shared/services/workflow-cart-support.service';
import { PdlModule } from '@experience/reb-pdl/pdl.module';
import { EntryModalComponent } from '@experience/shop/shared-browse/components/entry-modal/entry-modal.component';
import { ZipCodeValidationComponent } from '@experience/shop/shared-browse/components/zip-code-validation/zip-code-validation.component';
import { CreditComponent } from '@experience/shop/shared-browse/components/credit/credit.component';
import { PlanTypeComponent } from '@experience/shop/shared-browse/components/plan-type/plan-type.component';
import { ZipCodeRequiredGuardService } from '@experience/shop/services/zip-code-required-guard.service';
import { MarketingComponent } from '@root/shared/components/marketing/marketing.component';
import { MarketingService } from '@root/shared/services/marketing.service';
import { CustomeHandlerService } from '@root/shared/services/custome-handler.service';
import { PdpDataHandlerService } from '@root/shared/services/pdp-data-handler.service';
import { DigitalNavbarComponent } from './components/digital-navbar/digital-navbar.component';
import { DigitalFooterComponent } from './components/digital-footer/digital-footer.component';
import { PhoenixStateService } from './services/phoenix-state-service';
@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    RouterModule,
    WidgetsModule,
    FormsModule,
    ReactiveFormsModule,
    PdlModule,
  ],
  declarations: [
    FooterComponent,
    MarketingComponent,
    PlanTypeComponent,
    CreditComponent,
    ZipCodeValidationComponent,
    NavbarComponent,
    SplashPageComponent,
    GlobalErrorModalComponent,
    EntryModalComponent,
    AnchorDetectDirective,
    SearchComponent,
    DigitalNavbarComponent,
    DigitalFooterComponent,
  ],
  providers: [
    NavbarService,
    RepProfileService,
    UserService,
    SetFocusService,
    SearchService,
    CustomerProfileService,
    WorkflowService,
    WorkflowCartSupportService,
    ZipCodeRequiredGuardService,
    MarketingService,
    CustomeHandlerService,
    PdpDataHandlerService,
    PhoenixStateService
  ],
  exports: [
    MarketingComponent,
    FooterComponent,
    NavbarComponent,
    SplashPageComponent,
    GlobalErrorModalComponent,
    DigitalNavbarComponent,
    DigitalFooterComponent,
  ],
})
export class RootSharedModule {}
